// MODULES
import React from "react";

// COMPONENTS
import EditableField from "@routes/Cob/components/EditableField/EditableField";
import FieldsCollection from "@components/FieldsCollection/FieldsCollection";
import OptionsList from "@routes/Cob/components/OptionsList/OptionsList";
import Select from "@components/Select/Select";
import QuestionField from "@routes/Cob/components/QuestionField/QuestionField";

// HELPERS
import {createClassName} from "@helpers/utils";


export default class Collection extends React.PureComponent {

	render() {
		const {props} = this;
		const {index, fields, validFields, onFieldChange, onFieldBlur, onSelectChange, onOptionsListChange} = props;
		const classes = createClassName("Cob-Questionnaire-Collection", {
			"first": index === 0,
		});

		return (
			<div className={classes}>
				<h3>Frågor rörande lagen om penningtvätt och finansiering av terrorism</h3>

				<FieldsCollection
					fields={[
						{
							render: (
								<FieldsCollection
									fieldsPerRow={1}
									fields={[
										{
											render: (
												<FieldsCollection
													fields={[
														{
															render: (
																<OptionsList
																	type="radio"
																	orientation="horizontal"
																	name="checkbox_aml_own_money"
																	description="Äger du själv pengarna som kommer att placeras på kontot?"
																	options={fields.checkbox_aml_own_money.options}
																	onChange={onOptionsListChange}
																/>
															),
														},
													]}
												/>
											),
										},
										{
											display: fields.checkbox_aml_own_money.options[0].checked,
											render: (
												<div style={{display: "block", width: "560px", margin: "20px 0 0 0", background: "#FFEAEA", padding: "15px"}}>
													Kontoöppning tyvärr inte möjlig. Som kund hos oss måste du själv äga pengarna du vill placera på kontot.
												</div>
											),
										}
									]}
								/>
							),
						},
						{
							render: (
								<FieldsCollection
									fieldsPerRow={1}
									fields={[
										{
											render: (
												<QuestionField
													Component={Select}
													description="Vad har du för typ av anställning eller sysselsättning?"
													label="Välj"
													name={fields.checkbox_customer_kyc_empl.name}
													selectedIndex={fields.checkbox_customer_kyc_empl.index}
													options={fields.checkbox_customer_kyc_empl.options}
													onChange={onSelectChange}
												/>
											),
										},
										{
											display: fields.checkbox_customer_kyc_empl.index === 6,
											render: (
												<EditableField
													className="other-field"
													name="customer_kyc_empl_other"
													label="Annat"
													value={fields.customer_kyc_empl_other || ""}
													valid={validFields.customer_kyc_empl_other}
													onChange={onFieldChange}
													onBlur={onFieldBlur}
												/>
											),
										}
									]}
								/>
							),
						},
						{
							render: (
								<React.Fragment>
									<OptionsList
										style={{marginTop: "25px"}}
										type="checkbox"
										name="aml_origin_options"
										description="Varifrån kommer dina pengar?"
										orientation="vertical"
										onChange={onOptionsListChange}
										options={fields.aml_origin_options.options}
									/>
								</React.Fragment>
							),
						},
						{
							render: (
								<React.Fragment>
									<OptionsList
										style={{marginTop: "25px"}}
										type="radio"
										name="radio_aml_deposit_amt"
										description="Hur stora kommer dina insättningar att vara per år?"
										orientation="vertical"
										onChange={onOptionsListChange}
										options={fields.radio_aml_deposit_amt.options}
									/>
								</React.Fragment>
							),
						},
						{
							render: (
								<React.Fragment>
									<OptionsList
										style={{marginTop: "25px"}}
										type="radio"
										name="radio_aml_deposit"
										description="Hur ofta tänker du göra insättningar?"
										orientation="vertical"
										onChange={onOptionsListChange}
										options={fields.radio_aml_deposit.options}
									/>
								</React.Fragment>
							),
						},
						{
							render: (
								<FieldsCollection
									fieldsPerRow={1}
									fields={[
										{
											render: (
												<OptionsList
													style={{marginTop: "25px"}}
													type="checkbox"
													name="checkbox_customer_kyc_deposit"
													description="Från vilken bank/institut kommer du generellt göra överföringar?"
													orientation="vertical"
													onChange={onOptionsListChange}
													options={fields.checkbox_customer_kyc_deposit.options}
												/>
											),
										}
									]}
								/>
							),
						},
						{
							render: (
								<FieldsCollection
									fieldsPerRow={1}
									fields={[
										{
											render: (
												<OptionsList
													style={{marginTop: "25px"}}
													type="checkbox"
													name="checkbox_customer_kyc_purpose"
													description="Vad är syftet med ditt sparande och/eller dina placeringar?"
													orientation="vertical"
													onChange={onOptionsListChange}
													options={fields.checkbox_customer_kyc_purpose.options}
												/>
											),
										}
									]}
								/>
							),
						}
					]}
				/>

				{fields.checkbox_customer_kyc_empl.index !== -1 && fields.checkbox_customer_kyc_empl.index !== 6 && (
					<input type="hidden" name="customer_occupation"
						   value={fields.checkbox_customer_kyc_empl.options[fields.checkbox_customer_kyc_empl.index].label} />
				)}

				{fields.checkbox_customer_kyc_empl.index === 6 && (
					<input type="hidden" name="customer_occupation"
						   value={"Annat:" + fields.customer_kyc_empl_other} />
				)}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/fair-gds-oppna/Fields/collections/CollectionKyc.js